import { useState } from "react";
import { Navigate, Outlet, Route, Routes } from "react-router-dom";

import classes from "./Layout.module.css";
import SideBar from "../../components/SiderBar/SideBar";
import { useAuth } from "../../context/AuthContext";
import Bookings from "../Bookings/Bookings";
import Cars from "../Cars/Cars";
import Users from "../Users/Users";
import Members from "../Members/Members";
import Support from "../Support/Support";
import Insights from "../Insights/Insights";
import BookingsManagement from "../BookingsManagement/BookingsManagement";
import AddNewCar from "../AddNewCar/AddNewCar";
import CarDetails from "../CarDetails/CarDetails";
import UsersManagement from "../UsersManagement/UsersManagement";

const Layout = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [showLogoutCard, setShowLogoutCard] = useState(false);
  const [showLogoutConfirm, setShowLogoutConfirm] = useState(false);
  const { logout } = useAuth();

  const toggleLogoutCard = () => {
    setShowLogoutCard((prev) => !prev);
  };

  const handleLogoutClick = () => {
    setShowLogoutCard(false);
    setShowLogoutConfirm(true);
  };

  const handleConfirmLogout = () => {
    setShowLogoutConfirm(false);
    logout();
  };

  return (
    <div className={`${classes.main} d-flex`}>
      <SideBar mobileOpen={mobileMenuOpen} onClose={() => setMobileMenuOpen(false)} />
      {showLogoutConfirm && (
        <div className={classes.modalOverlay} onClick={() => setShowLogoutConfirm(false)}>
          <div className={classes.confirmModal} onClick={(e) => e.stopPropagation()}>
            <h3 className={classes.confirmTitle}>Log out</h3>
            <p className={classes.confirmText}>Are you sure you want to log out?</p>
            <div className={`d-flex gap-3 ${classes.confirmActions}`}>
              <button className={classes.cancelBtn} onClick={() => setShowLogoutConfirm(false)}>Cancel</button>
              <button className={classes.logoutBtn} onClick={handleConfirmLogout}>Log out</button>
            </div>
          </div>
        </div>
      )}
      <div className={classes.content}>
        <div className={`${classes.header} d-flex align-items-center justify-content-between justify-content-md-end`}>
          <button
            className={classes.hamburger}
            onClick={() => setMobileMenuOpen(true)}
            aria-label="Open menu"
          >
            <span />
            <span />
            <span />
          </button>
          <div>
            <div
              className={classes.avatarContianer}
              onClick={toggleLogoutCard}
              role="button"
            ></div>
            {showLogoutCard && (
              <div
                className={classes.logoutCard}
                onClick={handleLogoutClick}
                role="button"
              >
                Logout
              </div>
            )}
          </div>
        </div>
        <div className={classes.mainContent}>
          <Routes>
            <Route path="/" element={<Navigate to="/bookings" />} />
            <Route path="/bookings" element={<Bookings />} />
            <Route path="/bookings/bookings-management/:id" element={<BookingsManagement />} />
            <Route path="/cars" element={<Cars />} />
            <Route path="/cars/add-car" element={<AddNewCar />} />
            <Route path="/cars/edit-car/:id" element={<AddNewCar />} />
            <Route path="/cars/car-details/:id" element={<CarDetails />} />
            <Route path="/users" element={<Users />} />
            <Route path="/users/users-management/:id" element={<UsersManagement />} />
            <Route path="/members" element={<Members />} />
            <Route path="/support" element={<Support />} />
            <Route path="/insights" element={<Insights />} />
          </Routes>
        </div>
      </div>
    </div>
  );
};

export default Layout;
